import { render, staticRenderFns } from "./etablissement-detail-astreintes.vue?vue&type=template&id=5c73f518&scoped=true"
import script from "./etablissement-detail-astreintes.vue?vue&type=script&lang=js"
export * from "./etablissement-detail-astreintes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73f518",
  null
  
)

export default component.exports